import router from './router'
import { Message } from 'element-ui'

const whiteList = ['/login','/register'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  
  // determine whether the user has logged in
  const hasToken = localStorage.getItem('token')
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login`)
    }
  }
})

router.afterEach(() => {
  // finish progress bar

})



// WEBPACK FOOTER //
// ./src/permission.js